export let LabelPosition;(function(o){o["AUTO"]="AUTO";o["ALL_SIDES"]="ALL_SIDES"})(LabelPosition||(LabelPosition={}));